export { default } from './termTable';
